import { Colors } from "assets/colors";

export const styles: any = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& h3": {
      fontSize: "1.5rem",
      color: Colors.GrayText,
      fontWeight: 900,
    },
    "& img": {
      cursor: "pointer",
      padding: ".75rem 1rem",
    },
    paddingRight: ".5rem"
  },
  profile: {
    borderRadius: "50%",
    padding: ".5rem .7rem",
    backgroundColor: Colors.DarkGrayIconBox,
    color: Colors.BlackText,
    marginLeft: ".5rem",
    cursor: "pointer"
  }

} 
